module.exports = __webpack_public_path__ + "static/dinosaur-2a7d1955e0f2ceeb908d79e585c753d5.jpeg";